import React from 'react';
import {AllPermissions} from "../../components";

const Permissions = () => {
    return <AllPermissions/>;
};

export default Permissions;